import { ClientError } from 'graphql-request';

import { isResponseError } from './client/response-error';

/** Re-exported so consumers can recognise a GraphQL failure without depending on graphql-request. */
export { ClientError };

/**
 * The HTTP status behind a failed request, whichever client threw it: REST rejects with
 * `ResponseError`, GraphQL with `graphql-request`'s `ClientError`. Undefined for a network
 * failure, which never reached a response.
 */
export function errorStatus(error: unknown): number | undefined {
  if (isResponseError(error)) return error.status;
  if (error instanceof ClientError) return error.response.status;
  return undefined;
}
